import { gql } from '@apollo/client/core';

/** The selection list matches the fields `TicketSection.fromGql` reads exactly. */
export const TICKET_SECTION_FIELDS = gql`
  fragment TicketSectionFields on TicketSection {
    id
    name
    color
    quantity
    remaining
    editable
    deletable
  }
`;
